<template>
	<v-chip
		v-if="status"
		class="px-4"
		:class="{ 'text-only': text }"
		:color="color"
		:text-color="color"
		outlined
		@click.stop="action"
		v-on="on"
	>
		<v-icon left small v-text="icon" />
		<span v-text="spanText" />
	</v-chip>
</template>

<script>
import { get } from "lodash";

export default {
	props: {
		status: String,
		severity: String,
		action: {
			type: Function,
			default: () => () => {},
		},
		on: {
			type: Object,
			default: () => ({}),
		},
		text: Boolean,
	},

	data() {
		return {
			statusIcons: {
				DISABLED: {
					icon: "fa-ban",
					color: "grey",
				},
				NORMAL: {
					icon: "fa-check-circle",
					color: "ocean",
				},
				ACTIVE: {
					icon: "fa-triangle-exclamation",
					color: "rust-red",
				},
				ACKNOWLEDGED: {
					icon: "fa-dot-circle",
					color: "orange",
				},
				SNOOZED_DISABLED: {
					icon: "fa-bell-slash",
					color: "grey",
				},
			},
			icons: {
				NORMAL: "fa-check-circle",
				DEGRADED: "fa-exclamation",
				CRITICAL: "fa-triangle-exclamation",
			},
			colors: {
				NORMAL: "ocean",
				DEGRADED: "orange",
				CRITICAL: "rust-red",
			},
			statusObj: {
				DISABLED: "Disabled",
				NORMAL: "Normal",
				ACTIVE: "Active",
				ACKNOWLEDGED: "Acknowledged",
				SNOOZE_DISABLED: "Snoozed",
			},
		};
	},

	computed: {
		icon() {
			return get(
				this.icons,
				this.severity,
				get(this.statusIcons[this.status], "icon", "fa-question")
			);
		},
		color() {
			if (this.status.includes("DISABLED")) return "grey";
			return get(
				this.colors,
				this.severity,
				get(this.statusIcons[this.status], "color", "grey")
			);
		},
		spanText() {
			return this.statusObj[this.status] || "Unknown";
		},
	},
};
</script>

<style lang="scss" scoped>
.text-only {
	border: unset;
	pointer-events: none;
}

.fa-triangle-exclamation::before {
	content: "\f071";
}
</style>
